export interface ProductsOverviewSuccess {
  body: {
    results: B2cProductData[];
    totalResults: number;
  };
  type: ResponseStatus;
}

export interface ProductsOverviewParams {
  page: number;
  pageSize: number;
  search: string;
  refreshKey?: number;
  saltInfo?: boolean;
}

export interface B2cProductData {
  id: string;
  productName: string;
  manufacturerName: string;
  saltInfo: string;
  imageUrl: string;
  standardUnit?: string;
  drugType?: string;
  medicineType?: string;
}

export interface ProductDetailsSuccess {
  body: {
    id: string;
    productName: string;
    manufacturerName: string;
    saltInfo: string;
    transformedSaltInfo: string;
    standardUnit: string;
    drugType: string;
    imageUrl: string;
    medicineType: string;
    productMapId: string;
    productMapUuid: string;
  };
  type: ResponseStatus;
}

export interface ProductEditParams {
  id: string;
  b2bUnitCode: string;
  name: string;
  type: EditProductType;
}

export interface ProductEditSuccess {
  body: string;
  type: ResponseStatus;
}

export enum EditProductType {
  IMAGE_URL = "IMAGE_URL",
  PRODUCT_NAME = "PRODUCT_NAME",
  MANUFACTURER_NAME = "MANUFACTURER_NAME",
  STANDARD_UNIT = "STANDARD_UNIT",
  DRUG_TYPE = "DRUG_TYPE",
  MEDICINE_TYPE = "MEDICINE_TYPE",
  SALT_INFO = "SALT_INFO",
  TRANSFORMED_SALT_INFO = "TRANSFORMED_SALT_INFO",
}

// Product edit types for API integration
